import { gql } from '@apollo/client'

export const ASSISTANT_FIELDS_FRAGMENT = gql`
  fragment AssistantFields on Assistant {
    id
    workspaceId

    firstName
    lastName
    photoUrl
    title
    description
    defaultLanguage
    disc
    personalityNotes
    ownerId
    tierId
    defaultEventIds
    schedules {
      id
      name
      enabled
      scheduleType
      timeOfDay
      timezone
      prompt
      goalId
      preferredModel
      preferredTemperature
      templateIds
    }

    tier {
      id
      name
      description
      tools
      models
      events
      schedules
    }

    instructions {
      id
      toolId
      instructions
      preferredModel
      preferredTemperature
      templateIds
    }
    goals {
      id
      name
      description
      toolInstructions {
        id
        toolId
        instructions
        preferredModel
        preferredTemperature
        templateIds
      }
    }
    eventInstructions {
      id
      eventId
      instructions
      defaultAssistant
    }
    authorization {
      id
      tierId
      adminId
      userId
      email
    }
    availableTools {
      id
      label
      description
      allowed {
        templates
        temperature
        models
      }
      templateType
    }
  }
`
